module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.f4769f9.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.eot
 ** module id = 279
 ** module chunks = 2
 **/